export abstract class ShowInactiveService {
  public showInactive: boolean = false;
}
